import { translateToString } from '@nzyme/i18n/translateToString.js';
import { formatMoney } from '@nzyme/money/formatMoney.js';
import * as l from './formatProductPrice.loc.js';
/** @__NO_SIDE_EFFECTS__ */
export function formatProductPrice({ price, currency, type, lang }) {
    const formatted = formatMoney([price, currency]);
    if (type === 'SUBSCRIPTION') {
        return formatted + translateToString(l.perMonth, lang);
    }
    return formatted;
}
//# sourceMappingURL=formatProductPrice.js.map